import { BaseApi } from '@/helpers/base-api'

export default class ComboApi extends BaseApi {
  constructor () {
    super('/api/v1/')
    this.errorMessage = 'There was an issue when trying to fetch the combo boxes. If this error persists, please contact our support.'

  }
  public getActionTypeCombo = (): Promise<any[]> => this.instance.get('combo/action-types')
  public getPersonnelCombo = (): Promise<any[]> => this.instance.get('combo/personnel')
  public getClientsCombo = (): Promise<any[]> => this.instance.get('combo/clients')
  public getFuelTypeCombo = (): Promise<any[]> => this.instance.get('combo/fuel-types')
  public getContactTypeCombo = (): Promise<any[]> => this.instance.get('combo/contact-types')
  public getPlacementTypeCombo = (): Promise<any[]> => this.instance.get('combo/installation-placement-types')
  public getItemTypeCombo = (): Promise<any[]> => this.instance.get('combo/item-types')
  public getAppointmentStatusCombo = (): Promise<any[]> => this.instance.get('combo/appointment-status')
  public getInstallationsmCombo = (): Promise<any[]> => this.instance.get('combo/installations-all')
  public getPaymentTypeCombo = (): Promise<any[]> => this.instance.get('combo/payment-types')
  public getPersonnelPartnersCombo = (): Promise<any[]> => this.instance.get('combo/personnel-partners')
  public getInventoryItemsCombo = (): Promise<Record<string, any>[]> => this.instance.get(`items/combo`)
  public getPrioritiesCombo = (): Promise<Record<string, any>[]> => this.instance.get(`combo/priorities`)
  public getAppointmentsCancelReasonsCombo = (): Promise<AppointmentCancelReasonComboDto[]> => this.instance.get(`combo/appointments/cancel/reasons`)
  public getExpenseLabelsCombo = (): Promise<LabelComboDto[]> => this.instance.get(`combo/labels/expenses`)
}
